<template>
  <section>
      <VisualMain class="pc"></VisualMain>
      <VisualMobile class="mobile"></VisualMobile>

  </section>
</template>
<script>
import VisualMain from "../visual/index.vue"
import VisualMobile from "../mobile/visual/index.vue"

export default {
  components:{
    VisualMain,
    VisualMobile
  },
  created() {
    console.log("created")
  }
}
</script>
<style>
@media screen and (min-width: 320px) {
html {
  font-size: 21.33333333px;
}
}
@media screen and (min-width: 360px) {
html {
  font-size: 24px;
}
}
@media screen and (min-width: 375px) {
html {
  font-size: 25px;
}
}
@media screen and (min-width: 384px) {
html {
  font-size: 25.6px;
}
}
@media screen and (min-width: 390px) {
html {
  font-size: 26px;
}
}
@media screen and (min-width: 400px) {
html {
  font-size: 26.66666667px;
}
}
@media screen and (min-width: 414px) {
html {
  font-size: 27.6px;
}
}
@media screen and (min-width: 424px) {
html {
  font-size: 28.26666667px;
}
}
@media screen and (min-width: 480px) {
html {
  font-size: 32px;
}
}
@media screen and (min-width: 540px) {
html {
  font-size: 36px;
}
}
@media screen and (min-width: 720px) {
html {
  font-size: 48px;
}
}
@media screen and (min-width: 750px) {
html {
  font-size: 50px;
}
}
</style>
